module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._l((_vm.model.options), function(option, optI) {
    return (!_vm.disabledOptions.includes(option.id)) ? _c('a', {
      staticClass: "Toggle",
      class: {
        'Toggle--selected': _vm.currentOptionIndex === optI,
          'Toggle--disabled': _vm.disabledOptions.includes(option.id)
      },
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.selectOption(option, optI)
        }
      }
    }, [_c('div', {
      staticClass: "ToggleName"
    }, [_vm._v(_vm._s(_vm._f("ratio")(option.name)))])]) : _vm._e()
  }), (_vm.selectedOption.description && !_vm.areAllOptionsDisabled && !_vm.isCurrentOptionDisabled) ? _c('p', {
    staticClass: "f6 lh-copy measure gray"
  }, [_c('strong', [_vm._v(_vm._s(_vm._f("ratio")(_vm.selectedOption.name)))]), _vm._v(": "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.selectedOption.description)
    }
  })]) : _vm._e(), (_vm.selectedOption.customField) ? _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.selectedOption.customFieldData),
      expression: "selectedOption.customFieldData",
      modifiers: {
        "lazy": true
      }
    }],
    attrs: {
      "placeholder": _vm.selectedOption.description
    },
    domProps: {
      "value": (_vm.selectedOption.customFieldData)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.selectedOption, "customFieldData", $event.target.value)
      }
    }
  })]) : _vm._e(), (!_vm.areAllOptionsDisabled && _vm.isCurrentOptionDisabled) ? _c('p', {
    staticClass: "f6 lh-copy measure ToggleError dark-red"
  }, [_vm._v("Please select an available option")]) : _vm._e(), (_vm.isCustomFieldEmpty) ? _c('p', {
    staticClass: "f6 lh-copy measure ToggleError dark-red"
  }, [_vm._v("Please enter a description")]) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-c03a90e4!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/BookartCategory/BookartToggle/BookartToggle.vue
// module id = 194
// module chunks = 2